<template lang="pug">
  .payouts
    v-container.white(:class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pt-4 pb-0'" style="max-width: 600px")
      v-alert.ma-0(v-if="!stripeManaged" color='success' text)
        v-row(align='center' no-gutters)
          v-col.shrink.pr-3
            v-icon(color="success") mdi-alert-circle-outline
          v-col
            div.p2.success--text {{ $t('payout_settlement_period_will') }}
      v-alert.ma-0(v-else color='info' text)
        v-row(align='center' no-gutters)
          v-col.shrink.pr-3
            v-icon(color="info") mdi-alert-circle-outline
          v-col.pr-1
            div.p2.info--text {{ $t('alert_managed_by_stripe.text') }}
          v-col.shrink
            v-btn(color="info" small depressed @click="viewStripeDashboard" :loading="stripeDashboardLoading") {{ $t('alert_managed_by_stripe.button') }}
    .background-header.white
      v-container.pb-0.white(style="max-width: 600px")
        div.d-flex.ma-2
          v-text-field(v-model="searchFilters.keyword" hide-details dense outlined height="40" background-color="basic200" :placeholder="$t('search_payouts')")
            template(v-slot:append)
              eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
    v-container.white.py-2(style="max-width: 600px")
      div.d-flex
        v-spacer
        v-btn.label.pa-0.px-4(v-if="payouts.length > 0" color="primary400" text @click="exportCsv()")
          eva-icon.mt-1.mr-1(name="external-link-outline" :fill=" $vuetify.theme.themes[$theme].primary400" width="14")
          | {{ $t('export') }}
        v-btn.label.pl-0.pr-2(color="primary400" text @click="openFilterSheet()")
          eva-icon.mt-1.mr-1(name="options-2-outline" :fill=" $vuetify.theme.themes[$theme].primary400" width="14")
          | {{ $t('filter') }}

    v-container.py-2.px-0(v-if="searchFilters.salesDate.length > 0" :style="`max-width: 600px; background-color: ${$vuetify.theme.themes[$theme].basic600T08} !important`")
      div.d-flex
        span.ml-1
        v-chip.mx-1(v-if="searchFilters.salesDate.length > 0" color="basic600" close outlined close-icon="mdi-close" small @click:close="searchFilters.salesDate = []")
          template(v-if="searchFilters.salesDate.length > 1") {{ searchFilters.salesDate[0] | humanizeDate }} ~ {{ searchFilters.salesDate[1] | humanizeDate }}
          template(v-else) {{ searchFilters.salesDate[0] | humanizeDate }}
    v-container.pa-0(style="max-width: 600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(indeterminate color="primary" :width="2" :size="50")
      v-layout.my-6(v-else-if="payouts.length == 0")
        v-row.fill-height.ma-0(align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(contain style="width:80px; height:80px" :src="require('@/assets/images/icon_empty.png')")
            p.caption {{ $t('no_item_found') }}

      template(v-else v-for="(payout, index) in payouts")
        payout-item.list-item(:key="payout.uid" :payout="payout" :index="index" :class="payouts.length !== index + 1 || 'list-item-bottom'")

      y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")

    .modals
      y-bottom-sheet(v-model="showFilterSheet" inset scrollable max-width="600px")
        v-card
          v-card-title.px-4
            div.h6.basic800--text {{ $t('filter_payouts') }}
            v-spacer
            v-btn(color="white" text @click="clearFilter()")
              .button-Aa-small.primary400--text {{ $t('clear_filters') }}
            v-btn.px-4(color="textColorAccent" depressed height=32 dark @click="filterData()")
              .button-AA-small.basic100--text {{ $t('filter') }}
          v-divider.basic300
          v-card-text.px-4.pb-8
            div.mt-4
              p.mb-0.label.basic600--text {{ $t('sales_date') }}
              v-dialog(v-model="datePickerOpen" max-width="320px")
                template(v-slot:activator="{ on, attrs }")
                  v-text-field.mt-2(v-model="dateRangeText" dense solo flat outlined background-color="basic200" v-bind="attrs" v-on="on" append-icon="mdi-chevron-down" hide-details readonly type="button" style="text-align-last: left")
                v-date-picker(v-model="filter.salesDate" range no-title)
                  v-spacer
                  v-btn(color="white" text @click="pickDatesCancel()")
                    .button-Aa-small.primary400--text {{ $t('cancel') }}
                  v-btn.mr-2(color="textColorAccent" depressed height=32 dark @click="pickDates")
                    .button-AA-small.basic100--text OK
    .link
      a.d-none(ref='downloadLink')
</template>

<script>
import queryString from 'query-string'
import { mapActions, mapState } from 'vuex'
import PayoutItem from '@/components/PayoutItem.vue'

export default {
  name: 'Payouts',
  components: { PayoutItem },
  props: ['company'],
  data: () => ({
    menu: false,
    payouts: [],
    isFetching: false,
    page: 1,
    pageSize: 10,
    count: 0,
    filter: {
      salesDate:[],
    },
    datePickerOpen: false,
    searchFilters: {
      salesDate:[],
      keyword: '',
      statusIndex: 0
    },
    searchCountDown: null,
    showFilterSheet: false,
    stripeDashboardLoading: false,
    stripeManaged: false,
    yezzapaySettings: null
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    dateRangeText () {
      // Return date range as readable text
      if (this.filter.salesDate.length == 2) {
        return `${this.$options.filters.humanizeDate(this.filter.salesDate[0])} ~ ${this.$options.filters.humanizeDate(this.filter.salesDate[1])}`
      } else if (this.filter.salesDate.length == 1) {
        return this.$options.filters.humanizeDate(this.filter.salesDate[0])
      } else{
        return 'All dates'
      }
    },
    filterParams () {
      // Create GET params for querying payout list
      let params = {
        ordering: '-created',
        company: this.company.id,
        page: this.page,
        page_size: this.pageSize
      }

      // Assign date
      if(this.searchFilters.salesDate.length == 2){
        params.sales_date_after = this.searchFilters.salesDate[0]
        params.sales_date_before = this.searchFilters.salesDate[1]
      }else if(this.searchFilters.salesDate.length == 1){
        params.sales_date_after = this.searchFilters.salesDate[0]
        params.sales_date_before = this.searchFilters.salesDate[0]
      }

      // Search mode: lead.rid and free keyword
      if (this.searchFilters.keyword && this.searchFilters.keyword.length >= 2) {
        if(this.searchFilters.keyword.startsWith('#')) {
          params.rid = this.searchFilters.keyword.replace('#', '')
        }else{
          params.search = this.searchFilters.keyword
        }
      }
      return params
    }
  },
  mounted () {
    if(this.$route.query.page) this.page = parseInt(this.$route.query.page)
    this.$axios.get(`/yezzapays/?company=${this.company.id}`).then((response) => {
      if (response.data.results.length > 0 && response.data.results[0].active_fpx_provider === 'stripe') {
        this.yezzapaySettings = response.data.results[0]
        this.stripeManaged = true
      }
    })
    .finally(() => {
      this.fetchPayouts()
    })

  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      this.fetchPayouts()
    },
    searchFilters: {
      handler (val) {
        // Swap date order if inverted
        if(val.salesDate.length == 2 && val.salesDate[0] > val.salesDate[1]) {
          val.salesDate = [val.salesDate[1], val.salesDate[0]]
        }
        // Refetch payouts based on current filter
        if (this.searchCountDown) {
          clearTimeout(this.searchCountDown)
        }
        this.searchCountDown = setTimeout(() => {
          this.payouts = []
          this.page = 1
          this.fetchPayouts()
        }, 500)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchPayouts () {
      this.isFetching = true
      let url = `/payouts`
      this.$axios.get(url, { params: this.filterParams }).then((response) => {
        this.payouts = response.data.results
        this.count = response.data.count
      }).catch(() => {}).finally(() => { this.isFetching = false })
    },
    openFilterSheet () {
      this.filter.salesDate = this.searchFilters.salesDate
      this.showFilterSheet = true
    },
    filterData () {
      this.showFilterSheet = false
      this.searchFilters.salesDate = this.filter.salesDate
    },
    clearFilter () {
      this.showFilterSheet = false
      this.searchFilters.salesDate = []
    },
    clickOpenInvoice (invoice) {
      this.currentOpenInvoice = invoice
      this.openInvoiceDialog = true
    },
    pickDatesCancel () {
      this.filter.salesDate = this.searchFilters.salesDate
      this.datePickerOpen = false
    },
    pickDates () {
      this.datePickerOpen = false
    },
    exportCsv () {
      let params = this.filterParams
      delete params.page
      delete params.page_size
      let queryString = Object.keys(params).map(key => key + '=' + this.filterParams[key]).join('&')
      this.$axios.get(`/payouts/export_merchant_payout?company=${this.company.id}&${queryString}`)
        .then(resp => {
          let blob = new Blob([resp.data], { type: 'text/csv' })
          this.$refs.downloadLink.href = window.URL.createObjectURL(blob)
          this.$refs.downloadLink.download = "Payouts.csv"
          this.$refs.downloadLink.click()
          console.log(resp)

        })
        .catch(() => {})
    }
    ,
    viewStripeDashboard() {
      this.stripeDashboardLoading = true
      this.$axios.get(`/yezzapays/${this.yezzapaySettings.id}/get_stripe_link/?type=login`)
      .then(resp => {
        window.open(resp.data.url)
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.stripeDashboardLoading = false
      })
    }
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.list-item{
  border:1px solid var(--v-primary100);
  border-radius: 0;
  border-top:4px solid var(--v-primary200);
}
.list-item-bottom{
  border-bottom:4px solid var(--v-primary200);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:var(--v-basic100);
}
</style>

<i18n>
{
  "en": {
    "payout_settlement_period_will": "Payout settlement period will be within 3 working days after sales date.",
    "filter_payouts": "Filter Payouts",
    "clear_filters": "Clear filters",
    "search_payouts": "Search Payouts",
    "alert_managed_by_stripe": {
      "text": "Your Yezza Pay account is currently managed by Stripe",
      "button": "View Payout"
    }
  },
  "id": {
    "payout_settlement_period_will": "Periode penyelesaian pembayaran akan dilakukan dalam waktu 3 hari kerja setelah tanggal penjualan",
    "filter_payouts": "Filter Pembayaran",
    "clear_filters": "Bersihkan Filter",
    "sales_date": "Tanggal penjualan",
    "search_payouts": "Cari Pembayaran"
  }
}
</i18n>
